import { render, staticRenderFns } from "./perform-departure-control-for-driver.vue?vue&type=template&id=5d6bde95&scoped=true"
import script from "./perform-departure-control-for-driver.vue?vue&type=script&lang=js"
export * from "./perform-departure-control-for-driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bde95",
  null
  
)

export default component.exports